import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export type AutomationVersionsListParams = {
  automationId: string;
  limit?: number;
  offset?: number;
};

export type AutomationVersionRecord = {
  id: string;
  automationId: string;
  versionNumber: number;
  flowSnapshot: Record<string, unknown> | null;
  description: string | null;
  createdBy: string;
  createdByUser: {
    id: string;
    firstName: string;
    lastName: string;
  } | null;
  timestamps: {
    createdAt: string;
    updatedAt: string;
  };
};

export const automationVersionsListQueryAtom = createQueryAtomFactory(
  'automations.versions.list',
  (params: AutomationVersionsListParams) => ({
    automationVersions: {
      __args: {
        filter: {
          automationId: params.automationId,
        },
        sorting: ['VersionNumberDesc'],
        pagination: {
          limit: params.limit ?? 50,
          offset: params.offset ?? 0,
        },
      },
      page: {
        total: true,
      },
      entries: {
        id: true,
        automationId: true,
        versionNumber: true,
        flowSnapshot: true,
        description: true,
        createdBy: true,
        createdByUser: {
          id: true,
          firstName: true,
          lastName: true,
        },
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    },
  }),
  {
    select: ({
      automationVersions,
    }): { total: number; versions: AutomationVersionRecord[] } => ({
      versions: (automationVersions.entries ?? []).map(
        (v: Record<string, unknown>) => ({
          id: v.id as string,
          automationId: v.automationId as string,
          versionNumber: v.versionNumber as number,
          flowSnapshot: (v.flowSnapshot as Record<string, unknown>) ?? null,
          description: (v.description as string) ?? null,
          createdBy: v.createdBy as string,
          createdByUser:
            v.createdByUser as AutomationVersionRecord['createdByUser'],
          timestamps: v.timestamps as AutomationVersionRecord['timestamps'],
        }),
      ),
      total: (automationVersions.page?.total as number) ?? 0,
    }),
  },
);
